import { useEffect, useState } from "react";
import axios from "axios";

axios.defaults.baseURL = "https://opentdb.com/";
const UseAxios = ({ url }) => {
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fatchData = () => {
      axios
        .get(url)
        .then((res) => {
          setRes(res.data);
        })
        .catch((err) => {
          setErr(err);
        })
        .finally(() => setLoading(false));
    };
    fatchData();
  }, [url]);

  return { res, err, loading };
};

export default UseAxios;
